module.exports = __webpack_public_path__ + "static/glazial_white-31b226ca628f6cc23a60fa3e3e33699d.png";